<template>
  <div class="AppMultipleSelectionBar">
    <i18n-t
      keypath="common.selectedItems"
      tag="span"
      scope="global"
      :plural="items.length"
    >
      <template #count>
        <span class="text--x-small text--bold AppMultipleSelectionBar-counter mr-1">
          {{items.length}}
        </span>
      </template>
    </i18n-t>

    <div class="mx-4" style="height: 30px">
      <v-divider :vertical="true"/>
    </div>
    <!--
    Triggered on click. Bind this event to a reset selected items method
    @event deselectAll
  -->
    <div class="app-link"
         @click="$emit('deselectAll')"
    >
      {{ $t('common.deselectAll') }}
    </div>
    <div class="ml-auto">
      <!-- @slot Use this slot to add mas action buttons -->
      <slot name="buttons"></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppMultipleSelectionBar',
  props: {
    /**
     * Array of selected items
     */
    items: {
      type: Array,
      required: true,
    },
  },
})
</script>

<style scoped lang="scss">
.AppMultipleSelectionBar {
  display: flex;
  align-items: center;
  padding: 6px 24px;
  border: 2px solid rgb(var(--v-theme-primary));
  border-radius: 8px;
  
  &-counter {
    display: inline-block;
    text-align: center;
    width: 20px;
    height: 20px;
    border-radius: 25px;
    background-color: rgb(var(--v-theme-primary-lighten-5));
    color: rgb(var(--v-theme-primary));
  }
}
</style>

<!--<docs>-->
<!--```vue-->
<!--<template>-->
<!--  <AppMultipleSelectionBar :items="items">-->
<!--    <template #buttons>-->
<!--      <AppMultipleSelectionBarButton type="delete" />-->
<!--      <AppMultipleSelectionBarButton type="delete" />-->
<!--    </template>-->
<!--  </AppMultipleSelectionBar>-->
<!--</template>-->
<!--<script>-->
<!--  import AppMultipleSelectionBarButton from "@/design-system/multiple-selection-bar/AppMultipleSelectionBarButton.vue";-->
<!--  export default {-->
<!--    components: {-->
<!--      AppMultipleSelectionBarButton,-->
<!--    },-->
<!--    data () {-->
<!--      return {-->
<!--        items: ['a', 'b', 'c']-->
<!--      }-->
<!--    },-->
<!--  }-->
<!--</script>-->
<!--```-->
<!--</docs>-->
